export default [
  {
    path: '/web-management',
    name: 'web-management',
    component: () => import('../pages/web-management/slugs/slugs.shell.vue'),
  },
  {
    path: '/web-management/:slugId',
    name: 'web-management-slug',
    component: () => import('../pages/web-management/slugs/slugs.form.vue'),
  },
];
